import requireAuthorization from "@/routes/helper/requireAuthorization";
import i18n from "@/i18n";
import { RoleEnum } from "@/store/authentication/types";

export default [
    {
        path: "/",
        name: "instances",
        component: () => import("@/components/instances/_Instances.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/users", i18n.t("instances.title")]
                ]
            }
        }
    },
    {
        path: "/instanceGroups",
        name: "instanceGroups",
        component: () => import("@/components/instances/_InstanceGroups.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/instanceGroups", i18n.t("instanceGroups.title")]
                ]
            }
        }
    },
    {
        path: "/instanceGroups/create",
        name: "createInstanceGroup",
        component: () => import("@/components/instances/_InstanceGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/instanceGroups/create", i18n.t("instanceGroups.title")]
                ]
            }
        }
    },
    {
        path: "/instanceGroups/:groupId/update",
        name: "updateInstanceGroup",
        component: () => import("@/components/instances/_InstanceGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/instanceGroups/update", i18n.t("instanceGroups.title")]
                ]
            }
        },
        props: true
    }
];
